export const Collections = Object.freeze({
  USERS: "users",
  ORGANIZATIONS: "organizations",
  TEAMS: "teams",
  TEAM_MEMBERS: "teamMembers",
  ORGANIZATION_MEMBERS: "organizationMembers",
  ORGANIZATION_ROLES: "organizationRoles",
  TEAM_ROLES: "teamRoles",
  GOALS: "goals",
  GOAL_WEEKS: "goalWeeks",
  TEAM_INVITES: "teamInvites",
});
